export const ADMIN_SETTING_ROUTE_PATH = '/admin-setting';
export const CONTACT_SALES_SEGMENT = 'contact-sales';
export const CONTACT_SALES_ROUTE_PATH =
  `${ADMIN_SETTING_ROUTE_PATH}/${CONTACT_SALES_SEGMENT}` as const;
